module.exports = __webpack_public_path__ + "static/media/45_tn.7e63c580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/45_tn.jpg
// module id = 681
// module chunks = 0